import { useState } from 'react';

import companyInformation from '../../assets/icons/apartment.svg';
import CreditCard from '../../assets/icons/payment.svg';
import contactInformation from '../../assets/icons/phone.svg';
import personalInformation from '../../assets/icons/User.svg';
import { useRoot } from '../../context/RootProvider';
import VerticalTabs from '../../designComponents/VerticalTabs';
import { ItemWrapper } from '../../designComponents/VerticalTabs/styles';
import theme from '../../theme';
import AddBankAccount from './AddBankAccount';
import ChangePassword from './ChangePassword';
import CompanyInformation from './CompanyInformation';
import ContactInformation from './ContactInformation';
import PersonalInformation from './PersonalInformation';
import PrinterSettings from './PrinterSettings';
import ProfileInformation from './ProfileInformation';
import {
  SettingWrapperContainer,
  TabWrapper,
  TabWrapperForMobile,
  Wrapper,
} from './style';
import LicensesAndCertifications from './TechnicianFilesUpload';

const Settings = () => {
  const [activeTab, setActiveTab] = useState('tab1');
  const { auth } = useRoot();

  const handleVerticalTabChange = (key: string) => {
    setActiveTab(key);
  };

  /* ================= PRINTER ================= */
  const printerTabs = [
    {
      key: 'tab1',
      label: (
        <ItemWrapper>
          <img src={personalInformation} className="tab-icon" />
          Personal Information
        </ItemWrapper>
      ),
    },
  ];

  const commonTabs = [
    {
      key: 'tab1',
      label: (
        <ItemWrapper>
          <img src={personalInformation} className="tab-icon" />
          Personal Information
        </ItemWrapper>
      ),
    },
    {
      key: 'tab2',
      label: (
        <ItemWrapper>
          <img src={contactInformation} className="tab-icon" />
          Contact Information
        </ItemWrapper>
      ),
    },
    {
      key: 'tab3',
      label: (
        <ItemWrapper>
          <img src={companyInformation} className="tab-icon" />
          Company Information
        </ItemWrapper>
      ),
    },
    {
      key: 'tab4',
      label: (
        <ItemWrapper>
          <img src={CreditCard} className="tab-icon" />
          Payment Method
        </ItemWrapper>
      ),
    },
    {
      key: 'tab5',
      label: (
        <ItemWrapper>
          <img src={personalInformation} className="tab-icon" />
          Change Password
        </ItemWrapper>
      ),
    },
  ];

  const technicianTabs = [
    {
      key: 'tab1',
      label: (
        <ItemWrapper>
          <img src={personalInformation} className="tab-icon" />
          Personal Information
        </ItemWrapper>
      ),
    },
    {
      key: 'tab2',
      label: (
        <ItemWrapper>
          <img src={contactInformation} className="tab-icon" />
          Contact Information
        </ItemWrapper>
      ),
    },
    // {
    //   key: 'tab3',
    //   label: (
    //     <ItemWrapper>
    //       <img src={companyInformation} className="tab-icon" />
    //       Company Information
    //     </ItemWrapper>
    //   ),
    // },
    {
      key: 'tab4',
      label: (
        <ItemWrapper>
          <img src={companyInformation} className="tab-icon" />
          License & Certification
        </ItemWrapper>
      ),
    },
    {
      key: 'tab5',
      label: (
        <ItemWrapper>
          <img src={companyInformation} className="tab-icon" />
          Bank Account
        </ItemWrapper>
      ),
    },
    {
      key: 'tab6',
      label: (
        <ItemWrapper>
          <img src={personalInformation} className="tab-icon" />
          Change Password
        </ItemWrapper>
      ),
    },
  ];

  return (
    <SettingWrapperContainer>
      {auth?.role === 'PRINTER' && (
        <>
          <TabWrapper>
            <VerticalTabs items={printerTabs} activeKey={activeTab} />
          </TabWrapper>
          <PrinterSettings />
        </>
      )}

      {auth?.role === 'TECHNICIAN' && (
        <>
          <TabWrapper>
            <VerticalTabs
              items={technicianTabs}
              activeKey={activeTab}
              activeTabColor={theme.colors.primary}
              onChange={handleVerticalTabChange}
            />
          </TabWrapper>

          <Wrapper>
            <ProfileInformation />

            <TabWrapperForMobile>
              <VerticalTabs
                items={technicianTabs}
                activeKey={activeTab}
                activeTabColor={theme.colors.primary}
                onChange={handleVerticalTabChange}
              />
            </TabWrapperForMobile>

            <div style={{ width: '100%' }}>
              {
                {
                  tab1: <PersonalInformation />,
                  tab2: <ContactInformation />,
                  tab3: <CompanyInformation />,
                  tab4: <LicensesAndCertifications />,
                  tab5: <AddBankAccount />,
                  tab6: <ChangePassword />,
                }[activeTab]
              }
            </div>
          </Wrapper>
        </>
      )}

      {auth?.role !== 'PRINTER' && auth?.role !== 'TECHNICIAN' && (
        <>
          <TabWrapper>
            <VerticalTabs
              items={commonTabs}
              activeKey={activeTab}
              activeTabColor={theme.colors.primary}
              onChange={handleVerticalTabChange}
            />
          </TabWrapper>

          <Wrapper>
            <ProfileInformation />

            <TabWrapperForMobile>
              <VerticalTabs
                items={commonTabs}
                activeKey={activeTab}
                activeTabColor={theme.colors.primary}
                onChange={handleVerticalTabChange}
              />
            </TabWrapperForMobile>

            <div style={{ width: '100%' }}>
              {
                {
                  tab1: <PersonalInformation />,
                  tab2: <ContactInformation />,
                  // tab3: <CompanyInformation />,
                  tab4: <AddBankAccount />,
                  tab5: <ChangePassword />,
                }[activeTab]
              }
            </div>
          </Wrapper>
        </>
      )}
    </SettingWrapperContainer>
  );
};

export default Settings;
